/**
 * GA4 event helpers for the "Ask Durafoam Roofing" chatbot.
 * Tracking must never block or break the chat, so everything is guarded.
 */
type Gtag = (...args: unknown[]) => void;

export function trackChatEvent(
  event: "chat_opened" | "chat_question",
  label?: string,
): void {
  if (typeof window === "undefined") return;
  try {
    const g = (window as unknown as { gtag?: Gtag }).gtag;
    if (typeof g !== "function") return;
    g("event", event, {
      event_category: "engagement",
      event_label: label ?? "Ask Durafoam Roofing",
    });
  } catch {
    // Never let analytics interfere with the chat.
  }
}
